import React from 'react'
import { DividerStyle, Title } from '../../Trade.style'
import PropTypes from 'prop-types'

const Header = ({ title }) => {
  return (
    <>
      <Title>{title}</Title>
      <DividerStyle style={{ margin: '24px 0px' }} />
    </>
  )
}

Header.propTypes = {
  title: PropTypes.string
}

export default Header
